// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root__norxQOQ7{height:100%;width:100%}.root__norxQOQ7 .context-menu__fJIj0WOJ{position:absolute;z-index:7000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "root__norxQOQ7",
	"contextMenu": "context-menu__fJIj0WOJ"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
